export class IsActiveModel {
    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}